export default __webpack_public_path__ + "static/comfort-76162fbc77ce6c636787a75547fd8933.jpg";